export default __webpack_public_path__ + "static/media/bagus.2184f2bf.jpg";